export default __webpack_public_path__ + "static/media/timelineEdit.cdf1c4fc.svg";